<div style="{{boxStyle}}">
</div>
